module.exports = __webpack_public_path__ + "media/images/icons/icn_015-6071d26c34322ff96af9498aed17f45b.svg";